<template>
  <div class="head_know_module">
    <div v-for="(pItem,index) in knowModule" :key="index" class="know_item" @click="headProLink(index)">
      <span>{{pItem.name}}</span>
    </div>
  </div>
</template>
<script>
// import { eventBus } from '../../../common/util/eventBus.js';
export default {
  data() {
    return {
      knowModule: [
        { name: ' 博士讲堂' },
        { name: '专家解析' },
        { name: '权威报告' }
      ]
    };
  },
  methods: {
    headProLink(pItem) {
      let tempStr = '';
      switch (pItem) {
        case 0:
          tempStr = 'doctorSpace';
          break;
        case 1:
          tempStr = 'opinion';
          break;
        case 2:
          tempStr = 'authoritative';
          break;
      }
      this.$router.push({ name: tempStr });
    }
    // proBusNoTrans(numbers) {
    //   eventBus.$emit('enProMdulePlayer', numbers);
    // }
  }
};
</script>
<style lang="stylus" scoped>
.head_know_module {
  background-color: #F1F3F4;
  width: 110px;

  .know_item {
    font-size: 16px;
    width: 110px;
    line-height: 35px;
    height: 35px;
    text-align: center;
    padding: 5px 0;
  }

  .know_item:hover {
    background-color: #11407C;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/header/knowledge.vue